/**
 * Nos activites make the card same height
 */

export const nosActivitesCardHeight = () => {
  (function ($) {
    if($('.nos-activites-content__card-title').length === 0) {
      return;
    }

    let maxHeight = 0;
    $('.nos-activites-content__card-title').each(function(){
      if(maxHeight < $(this).height()) {
        maxHeight = $(this).height();
      }
    })
    if(window.innerWidth >= 1024) {
      $('.nos-activites-content__card-title').css('min-height', maxHeight);
    }
  })(jQuery);
}